import type { OptionsDocument } from 'paintscout'
import type { LeadFormOption } from '..'

export function getLeadFormOptions(args: { options: OptionsDocument }): LeadFormOption[] {
  const { options } = args
  const leadFormOptions = options?.options?.leadForms
  if (!leadFormOptions) {
    return []
  }

  return leadFormOptions.order
    .map((orderItem) => {
      const item = leadFormOptions.values[orderItem]
      if (!item || item.deleted) {
        return null
      }
      return {
        key: orderItem,
        ...item
      }
    })
    .filter((item) => item)
}
